<template>
  <div class="c-upload-cont">
    <div class="c-single-uploader-lable">{{ label }}</div>
    <div>
      <div v-for="(image, index) in images" :key="image">
        <input
          type="hidden"
          v-model="images[index]"
          :key="index"
          name="images[]"
        />
      </div>
      <input
        accept="image/jpeg,image/png,image/jpg,image/webp"
        type="file"
        ref="file"
        class="custom-file-input d-none"
        id="c-images"
        multiple
        @change="uploader"
      />
      <div
        v-if="!images.length"
        class="c-upload-droper"
        for="customFile"
        @click="$refs.file.click()"
      >
        <div>
          <div class="c-upload-group">
            <div class="c-upload-icon">
              <span class="mdi mdi-cloud-upload"></span>
            </div>
            <div class="c-upload-browse">{{ trans('Browse files') }}</div>
          </div>
        </div>
      </div>

      <div v-else class="c-upload-droper p-0">
        <draggable
          v-model="images"
          draggable=".v-upload-image-cont"
          @start="drag = true"
          @end="drag = false"
        >
          <div
            v-for="(image, index) in images"
            :key="image"
            class="v-upload-image-cont"
          >
            <div
              class="v-upload-image-delete"
              :data-id="index"
              @click="deleteImage(index)"
            >
              <span class="mdi mdi-close"></span>
            </div>
            <img :src="image" class="v-upload-image" />
          </div>
          <div
            slot="footer"
            class="v-upload-image-add"
            @click="$refs.file.click()"
          >
            <div class="c-upload-image-add-border">
              <div class="c-upload-image-add-fixer">
                <div class="c-upload-icon">
                  <span class="mdi mdi-plus"></span>
                </div>
                <div class="c-upload-drag">{{ trans('Add more images') }}</div>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <br />
    <v-dialog
      v-model="dialog"
      persistent
      width="700"
      content-class="v-application"
    >
      <v-card>
        <v-card-title class="headline">
          {{ trans('Crop Image') }}
        </v-card-title>
        <v-card-text>
          <vue-croppie
            ref="croppieRef"
            :enableOrientation="true"
            :boundary="{ width: 480, height: 320 }"
            :viewport="{ width: 420, height: 280, type: 'square' }"
            :showZoomer="true"
            :enableResize="false"
            :enableZoom="true"
            :enforceBoundary="true"
          ></vue-croppie>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialog = false" class="mr-3">
            {{ trans('Cancel') }}
          </v-btn>
          <v-btn color="primary" @click="crop">
            {{ trans('Crop and Add') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css';
import draggable from 'vuedraggable';
import Vue from 'vue';
Vue.use(VueCroppie);

export default {
  props: ['data', 'label'],
  data() {
    return {
      croppieImage: '',
      cropped: null,
      dialog: false,
      images: [],
      multiCropper: { index: 0, finalIndex: 0, event: null },
      cropperReady: true,
    };
  },
  components: {
    draggable,
  },
  methods: {
    wait(ms) {
      ms = ms * 1000;
      var start = new Date().getTime();
      var end = start;
      while (end < start + ms) {
        end = new Date().getTime();
      }
    },
    deleteImage(index) {
      this.images.splice(index, 1);
    },
    uploader(e) {
      this.dialog = true;
      setTimeout(() => this.multiCroppie(e), 500);
    },
    multiCroppie(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      if (this.multiCropper.index == 0) {
        this.multiCropper.event = e;
        this.multiCropper.finalIndex = files.length - 1;
      }

      this.croppie(e, this.multiCropper.index);
    },
    croppie(e, index) {
      //this.wait(3)
      var files = e.target.files || e.dataTransfer.files;

      var reader = new FileReader();
      reader.onload = e => {
        this.$refs.croppieRef.bind({
          url: e.target.result,
        });
      };
      reader.readAsDataURL(files[index]);
    },
    crop() {
      this.dialog = false;
      // Options can be updated.
      // Current option will return a base64 version of the uploaded image with a size of 600px X 450px.
      let options = {
        type: 'base64',
        format: 'webp',
        size: { width: 1200, height: 800 },
      };

      this.$refs.croppieRef.result(options, output => {
        this.cropped = this.croppieImage = output;
        this.images.push(output);
      });

      if (this.multiCropper.index < this.multiCropper.finalIndex) {
        this.multiCropper.index++;
        this.uploader(this.multiCropper.event);
      } else {
        this.$refs.file.value = '';
        this.multiCropper = { index: 0, finalIndex: 0, event: null };
      }
    },
  },
  mounted() {
    if (this.data != null) {
      this.images = this.data;
    }
  },
  watch: {
    images: function() {
      this.$emit('newImgs', this.images);
    },
  },
};
</script>

<style lang="scss"  scoped>
@import './styles/multi-image-upload.scss';
</style>
